import { render, staticRenderFns } from "./petrolfeedback.vue?vue&type=template&id=7ca7978c&"
import script from "./petrolfeedback.vue?vue&type=script&lang=js&"
export * from "./petrolfeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports